export const getEnvironmentName = (): string => {
  return process.env.REACT_APP_ENVIRONMENT_TYPE || "development";
};

export const getBaseUrl = (): string => {
  return process.env.REACT_APP_API_BASE_URL || "";
};

export const getSiteLogoUrl = (): string => {
  return process.env.REACT_APP_SITE_LOGO || "";
};

export const ENV = {
  workspace:
    process.env.REACT_APP_WORKSPACE === "main"
      ? "lazzlek"
      : process.env.REACT_APP_WORKSPACE,
  workspaceId: process.env.REACT_APP_WORKSPACE_ID
};
